export const TOP_LEVEL_PAGES = [
  {
    scope: ["SUPER_ADMIN", "VALMONT_REP", "VALMONT_FINANCE", "FARM", "STRATEGIC_ACCOUNT"],
    path: "/",
    display: "Dashboard",
  },
  {
    scope: ["SUPER_ADMIN", "VALMONT_REP", "VALMONT_FINANCE", "FARM", "STRATEGIC_ACCOUNT"],
    path: "/reports",
    display: "Reports",
  },
  {
    scope: ["SUPER_ADMIN", "VALMONT_REP", "VALMONT_FINANCE", "STRATEGIC_ACCOUNT"],
    path: "/statements",
    display: "Statements",
  },
  {scope: ["SUPER_ADMIN", "VALMONT_REP", "VALMONT_FINANCE"],
    path: "/accounts",
    display: "Accounts",
  },
  {scope: ["STRATEGIC_ACCOUNT"],
    path: "/account",
    display: "Account",
  },
  {scope: ["FARM"],
    path: "/farm",
    display: "My Farm",
  },
  {
    scope: ["SUPER_ADMIN", "VALMONT_REP", "VALMONT_FINANCE"],
    path: "/valley-users",
    display: "Valley Users",
  },
  {
    scope: ["SUPER_ADMIN", "VALMONT_REP", "VALMONT_FINANCE"],
    path: "/dealers",
    display: "Dealers",
  }
];

export const CUSTOMER_TYPE_NONE_FILTER_VALUE = "__CUSTOMER_TYPE_NONE__";

export const CUSTOMER_TYPE_FILTER_OPTIONS = [
  { value: "VALLEY_BLUE", label: "Valley Blue" },
  { value: "NATIONAL", label: "National Account" },
  { value: CUSTOMER_TYPE_NONE_FILTER_VALUE, label: "None" },
];

export const CUSTOMER_TYPE_OPTIONS = [
  { id: "", name: "None" },
  { id: "VALLEY_BLUE", name: "Valley Blue" },
  { id: "NATIONAL", name: "National Account" },
];

export const CUSTOMER_TYPE_LABELS = {
  VALLEY_BLUE: "Valley Blue",
  NATIONAL: "National Account",
};

export const CUSTOMER_TYPE_CHIP_COLORS = {
  VALLEY_BLUE: { bg: "#E3F2FD", color: "#1565C0" },
  NATIONAL: { bg: "#F5F5F5", color: "#424242" },
};

export function resolveCustomerType(account) {
  if (!account) return null;
  if (account.customer_type) return account.customer_type;

  let parent = account.parent_account;
  while (parent) {
    if (parent.account_type === "STRATEGIC_ACCOUNT") {
      return parent.customer_type || null;
    }
    parent = parent.parent_account;
  }

  return null;
}
